import * as Yup from 'yup'
import { FormItemProps } from '@/components/Form/types'



const items: Array<FormItemProps> = [
	{
		name: 'id',
		type: 'Hidden',
	},
	{
		name: 'laser_properties_id',
		type: 'Hidden',
	},

	{
		name: 'name',
		label: 'Name',
		placeholder: 'Enter laser profile name',
		type: 'Text',
		classNames: {container: 'col-span-12'},
		validation: Yup.string().matches(/^[^`~!@#$%^&*;:'",.?\\()[\]{}<>+=|=-]+$/, 'Invalid characters'),
	},
	{
		name: 'description',
		label: 'Description',
		placeholder: 'Enter description',
		type: 'LongText',
		classNames: {container: 'col-span-12'},
	},
	{
		name: 'wobble_thickness',
		label: 'Wobble Thickness (mm)',
		placeholder: 'Thickness',
		type: 'Number',
		itemOptions: {
			step: 0.1
		},
		classNames: {container: 'col-span-4'},
		defaultValue: '0.0',
	},
	{
		name: 'wobble_overlap_percentage',
		label: 'Wobble Overlap Percentage (%)',
		placeholder: 'Overlap',
		type: 'Range',
		itemOptions: {
			min: 0,
			max: 100,
			step: 0.1,
		},
		classNames: {container: 'col-span-4'},
		defaultValue: '80.0',
	},

	{
		name: 'power',
		label: 'Power (%)',
		placeholder: 'Power',
		type: 'Range',
		itemOptions: {
			min: 0,
			max: 100,
			step: 0.1,
		},
		classNames: {container: 'col-span-4'},
		defaultValue: '45.0',
	},
	{
		name: 'jump_speed',
		label: 'Jump Speed (mm/s)',
		placeholder: 'Speed',
		type: 'Number',
		classNames: {container: 'col-span-4'},
		defaultValue: '6000.0',
	},
	{
		name: 'jump_delay',
		label: 'Jump Delay (µs)',
		placeholder: 'Delay',
		type: 'Number',
		classNames: {container: 'col-span-4'},
		defaultValue: '400',
	},
	{
		name: 'divider_jump',
		type: 'Divider',
		classNames: {container: 'col-span-4 opacity-0'},
	},
	{
		name: 'marking_speed',
		label: 'Marking Speed (mm/s)',
		placeholder: 'Speed',
		type: 'Number',
		classNames: {container: 'col-span-4'},
		defaultValue: '6000.0',
	},
	{
		name: 'mark_delay',
		label: 'Mark Delay (µs)',
		placeholder: 'Delay',
		type: 'Number',
		classNames: {container: 'col-span-4'},
		defaultValue: '400',
	},
	{
		name: 'divider_mark',
		type: 'Divider',
		classNames: {container: 'col-span-12'},
	},
	{
		name: 'laser_on_delay',
		label: 'Laser On Delay (µs)',
		placeholder: 'Delay',
		type: 'Number',
		classNames: {container: 'col-span-4'},
		defaultValue: '60',
	},
	{
		name: 'laser_off_delay',
		label: 'Laser Off Delay (µs)',
		placeholder: 'Delay',
		type: 'Number',
		classNames: {container: 'col-span-4'},
		defaultValue: '60',
	},
	{
		name: 'poly_delay',
		label: 'Poly Delay (µs)',
		placeholder: 'Delay',
		type: 'Number',
		classNames: {container: 'col-span-4'},
		defaultValue: '0',
	},
	{
		name: 'pipeline_delay',
		label: 'Pipeline Delay (µs)',
		placeholder: 'Delay',
		type: 'Number',
		classNames: {container: 'col-span-4'},
		defaultValue: '400',
	},
	{
		name: 'modulation_frequency',
		label: 'Modulation Frequency (kHz)',
		placeholder: 'Frequency',
		type: 'Number',
		classNames: {container: 'col-span-4'},
		defaultValue: '15.0',
	},
	{
		name: 'repeat_count',
		label: 'Repeat Count',
		placeholder: 'Count',
		type: 'Number',
		classNames: {container: 'col-span-4'},
		defaultValue: '1',
	},
	{
		name: 'pulse_waveform',
		label: 'Pulse Waveform',
		placeholder: 'Count',
		type: 'Hidden',
		classNames: {container: 'col-span-4'},
		defaultValue: '0',
	},
	{
		name: 'divider_velocity',
		type: 'Divider',
		classNames: {container: 'col-span-12'},
		label: 'Velocity Compensation'
	},
	{
		name: 'velocity_compensation_mode',
		label: 'Mode',
		placeholder: 'Mode',
		type: 'Select',
		itemOptions: {
			list: [
				{ label: 'Enabled', value: 'enabled' },
				{ label: 'Disabled', value: 'disabled' },
			]
		},
		classNames: {container: 'col-span-4'},
		defaultValue: {value: 'disabled'},
	},
	{
		name: 'velocity_compensation_limit',
		label: 'Limit (%)',

		type: 'Range',
		itemOptions: {
			min: 0,
			max: 100,
			step: 0.1,
		},
		classNames: {container: 'col-span-4'},
		defaultValue: '50.0',
		condition: (data:any) => data?.velocity_compensation_mode?.value === 'enabled',
	},
	{
		name: 'velocity_compensation_aggressiveness',
		label: 'Aggressiveness',
		placeholder: 'Count',
		type: 'Number',
		classNames: {container: 'col-span-4'},
		defaultValue: '1200.0',
		condition: (data:any) => data?.velocity_compensation_mode?.value === 'enabled',
	},
	{
		name: 'divider_radial_error',
		type: 'Divider',
		classNames: {container: 'col-span-12'},
	},
	{
		name: 'max_radial_error',
		label: 'Max Radial Error (mm)',
		placeholder: 'Max error',
		type: 'Number',
		classNames: {container: 'col-span-4'},
		defaultValue: '0.1',
	},
	{
		name: 'break_angle',
		label: 'Break Angle',
		placeholder: 'Count',
		type: 'Number',
		classNames: {container: 'col-span-4'},
		defaultValue: '0.7853982',
	}
]


export default items